/**
 * 4-char uppercase file extension used in attachment chips when no image
 * thumbnail is available. Returns `FILE` for dotless names or trailing dots.
 * Phase 4cc C1 extracted this from Composer/MessageBubble so both surfaces
 * render the same placeholder glyph.
 */
export function fileExt(name: string): string {
  const dot = name.lastIndexOf('.');
  if (dot === -1 || dot === name.length - 1) {
    return 'FILE';
  }
  return name
    .slice(dot + 1)
    .toUpperCase()
    .slice(0, 4);
}
